"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Title = void 0;
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
exports.Title = function (props) {
    var text = props.text;
    return (react_1.default.createElement(core_1.Grid, { item: true },
        react_1.default.createElement(core_1.Typography, { variant: "h5", component: "h3" },
            react_1.default.createElement(core_1.Box, { fontSize: "18px", fontWeight: "600" }, text))));
};
